import type { QueryClient } from "@tanstack/react-query";
import { userBalanceDetailsQueryKey } from "@/features/balance/utils/user-balance-details-query";
import { BalanceApi } from "@/openapi/generated";
import { createAuthenticatedApi } from "@/lib/utils";

export async function prefetchBalanceUserDetailsGet(
  userId: number,
  queryClient: QueryClient,
  accessToken?: string,
) {
  if (!accessToken) {
    throw new Error("Access token is required for prefetching balance user details");
  }

  const service = createAuthenticatedApi(BalanceApi, accessToken);

  await queryClient.prefetchQuery({
    queryKey: userBalanceDetailsQueryKey(userId),
    queryFn: async () => {
      try {
        const data = await service.apiBalanceUserIdDetailsGet({ id: userId });
        return data;
      } catch (error) {
        console.error("[BalancePage SSR] balance user details failed", { userId, error });
        // API may return error; avoid crashing SSR
        return [];
      }
    },
    staleTime: 2 * 60 * 1000,
  });

  return queryClient;
}
